export function minutesToSeconds(minutes: number) {
    return (minutes ?? 0) * 60;
}
